// extracted by mini-css-extract-plugin
export default {"notificationsStroke":"_8klKV","notificationsFill":"_7uvDh"};